import { RequireAutorization } from './routerAuth'
const Financial = () => import(/* webpackChunkName: "financial" */ '@/components/financial/Index.vue')

export const ROUTE_FINANCIAL = [{
  name: 'Financial',
  path: '/financeiro',
  component: Financial,
  meta: { title: 'Financeiro' },
  beforeEnter: RequireAutorization
}]
